import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Clock, DollarSign, Users } from "lucide-react";

export default function ProjectCard({ project }) {
  return (
    <Link to={`/projects/${project.project_id}`} data-testid={`project-card-${project.project_id}`}>
      <Card className="lift border border-border h-full bg-card">
        <CardContent className="p-6 flex flex-col h-full">
          <div className="flex items-start justify-between gap-3 mb-3">
            <Badge variant="secondary" className="uppercase text-[10px] tracking-widest font-semibold rounded-sm">
              {project.category}
            </Badge>
            <span className={`text-[10px] tracking-widest uppercase font-semibold px-2 py-0.5 rounded-sm ${
              project.status === 'open' ? 'bg-primary/10 text-primary' :
              project.status === 'in_progress' ? 'bg-amber-500/10 text-amber-600' :
              'bg-muted text-muted-foreground'
            }`}>
              {project.status === 'open' ? 'Abierto' : project.status === 'in_progress' ? 'En curso' : 'Completado'}
            </span>
          </div>
          <h3 className="font-heading font-semibold text-lg leading-tight mb-2 tracking-tight">
            {project.title}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-2 mb-4 flex-1">
            {project.description}
          </p>
          <div className="flex flex-wrap gap-1.5 mb-4">
            {(project.skills || []).slice(0, 4).map((s) => (
              <span key={s} className="text-[11px] px-2 py-0.5 rounded-sm bg-accent text-accent-foreground">
                {s}
              </span>
            ))}
          </div>
          <div className="flex items-center justify-between pt-3 border-t border-border text-xs text-muted-foreground">
            <span className="flex items-center gap-1 font-medium text-foreground">
              <DollarSign className="w-3.5 h-3.5" />
              {project.budget?.toFixed(0)}
            </span>
            <span className="flex items-center gap-1">
              <Clock className="w-3.5 h-3.5" />
              {project.deadline_days}d
            </span>
            <span className="flex items-center gap-1">
              <Users className="w-3.5 h-3.5" />
              {project.proposals_count || 0} propuestas
            </span>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
